import request from '@/utils/server'
// 新增功能间
export function addRoom(data) {
    return request({
      url: '/room/addRoom',
      method: 'POST',
      data: data
    })
  }
  // 请求功能间列表
 export function getRoomList(query) {
    return request({
      url: '/room/getRoomList',
      method: 'get',
      params: query
    })
  }
  // 删除功能间
  export function delRoom(data) {
    return request({
      url: '/room/delRoom',
      method: 'POST',
      data: data
    })
  }